  <div class="sidebar-wrapper">
      <div>
          <div class="logo-wrapper">
              <router-link to="/" > INVOICEX</router-link>
          </div>
      </div>
      <div class="sidebar-menu">
          <ul class="sidebar-list" v-if="!isSmallScreen">
             <li class="sidebar-item-title">
                <div class="box">
                    <div class="title"><h5>TỔNG QUAN</h5></div>
                </div>
             </li>
              <li class="sidebar-item" v-for="(itemMenu, keyGeneral) in generalMenu" :key="keyGeneral">
                  <div class="title d-flex justify-content-between" ref="sidebar-item-title" @click="toggleSubMenu(itemMenu.id)">
                      <div class="left d-flex align-items-center gap-2">
                          <component :is="getIcon(itemMenu.icon)" />
                          <span :style="{ color: itemMenu.isActive ? '#3cc89e' : '#3a3a3a' }" v-if="itemMenu.subMenu">{{itemMenu.label}}</span>
                          <RouterLink :style="{ color: itemMenu.isActive ? '#3cc89e' : '#3a3a3a' }" v-else :to="{ name: itemMenu.name }">{{itemMenu.label}}</RouterLink>
                      </div>
                      <div class="right" v-if="Object.keys(itemMenu.subMenu).length > 0">
                          <IconChevronRight></IconChevronRight>
                      </div>
                  </div>
                  <ul class="sidebar-item-children" :class="{'active': itemMenu.isActive}" ref="sidebar-item-children">
                      <li v-for="(subChild, key) in itemMenu.subMenu" class="sidebar-child" @click="toggleSubMenu(itemMenu.id, key)"><RouterLink :style="{ color: subChild.isActive ? '#3cc89e' : '#3a3a3a' }" :to="{ name: subChild.name }">{{subChild.label}}</RouterLink></li>
                  </ul>
              </li>
              <li class="sidebar-item-title">
                  <div class="box">
                      <div class="title"><h5>LIÊN KẾT NGOÀI</h5></div>
                  </div>
              </li>
              <li class="sidebar-item" v-for="(itemMenu, keySync) in externalMenu" :key="keySync">
                  <div class="title d-flex justify-content-between" ref="sidebar-item-title" @click="toggleSubMenu(itemMenu.id)">
                      <div class="left d-flex align-items-center gap-2">
                          <component :is="getIcon(itemMenu.icon)" />
                          <span v-if="itemMenu.subMenu">{{itemMenu.label}}</span>
                          <RouterLink v-else :to="{ name: itemMenu.name }">{{itemMenu.label}}</RouterLink>
                      </div>
                      <div class="right" v-if="Object.keys(itemMenu.subMenu).length > 0">
                          <IconChevronRight></IconChevronRight>
                      </div>
                  </div>
                  <ul class="sidebar-item-children" :class="{'active': itemMenu.isActive}" ref="sidebar-item-children">
                      <li v-for="subChild in itemMenu.subMenu" class="sidebar-child"><RouterLink :to="{ name: subChild.name }">{{subChild.label}}</RouterLink></li>
                  </ul>
              </li>
          </ul>
          <ul class="sidebar-list" v-else>
              <li class="sidebar-item-title">
                  <div class="box">
                      <div class="title">GENERAL</div>
                  </div>
              </li>
              <li class="sidebar-item" :class="{'is_submenu': isSmallScreen, 'open': itemMenu.isActive}" v-for="itemMenu in dataMenu" :key="itemMenu.id">
                  <div class="title" ref="sidebar-item-title" @click="toggleSubMenu(itemMenu.id)">
                      <div class="left d-flex gap-2">
                          <component :is="getIcon(itemMenu.icon)" />
                      </div>
                  </div>
                  <ul class="sidebar-item-children" :class="{'active': itemMenu.isActive}" ref="sidebar-item-children">
                      <li v-for="subChild in itemMenu.subMenu" class="sidebar-child">
                          <component :is="getIcon(subChild.icon)" />
                      </li>
                  </ul>
              </li>
          </ul>
      </div>
  </div>
